import { Component, EventEmitter, Output } from '@angular/core'
import { WindowRef } from '@spartacus/core'

@Component({
  selector: 'mb-checkout-new-address-tile',
  templateUrl: './mb-checkout-new-address-tile.component.html',
  styleUrls: ['./mb-checkout-new-address-tile.component.scss']
})
export class MbCheckoutNewAddressTileComponent {

  @Output() addNewAddress = new EventEmitter<any>()

  constructor (protected winRef: WindowRef) {
  }

  clickHandler (value: any): void {
    this.addNewAddress.emit(value)
    this.winRef.nativeWindow?.scroll({ top: 0, behavior: 'smooth' })
  }
}
